import yup from '../../../../helpers/yupInstance';
import type { TFunction } from 'i18next';

export function getAddAiPromptFormValidation(t: TFunction) {
  return yup.object({
    key: yup
      .string()
      .max(256, t('formikValidation.maxLength').replace('{0}', '256'))
      .required(t('formikValidation.keyRequired')),
    value: yup.string().required(t('formikValidation.valueRequired')),
  });
}
